import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { Group } from '@thiememeulenhoff/types';

export const groups = createStore(
  { name: 'groups' },
  withEntities<Group, 'id'>({
    idKey: 'id',
  }),
);
